var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadLogoReaper = function SvgFadLogoReaper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.72 208.484c-37.618 0-77.265-80.452-77.265-105.629 0-19.517 18.03-55.275 77.043-55.275 59.014 0 77.62 32.37 77.62 52.373 0 31.637-39.778 108.531-77.397 108.531z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.656 77.857s8.746 15.42 22.838 30.632c14.092 15.212 17.522 11.385 22.54 33.827 5.019 22.442-1.204 50.825-1.204 50.825s11.08-21.784 11.08-36.443c0-23.852-6.068-30.241-13.28-43.975-7.213-13.734-16.075-23.114-16.075-23.114s25.496-8.165 39.203-6.152c23.795 3.494 45.404 20.895 45.404 20.895s-14.317-22.55-47.896-34.606c-17.642-6.334-29.372-2.897-38.786-.98-9.414 1.916-23.824 9.091-23.824 9.091z",
    fill: "#FFF"
  }))));
};
export { SvgFadLogoReaper as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-logo-reaper.84f6ba90.svg";